import React from 'react';

const LoadingSpinner = ({className = ""}) => {
  return <svg className={"load-spinner " + className} style={{width: 40, height: 40}} viewBox={"0 0 66 66"} xmlns={"http://www.w3.org/2000/svg"}>
    <circle className={"path"} fill={"none"} strokeWidth={6} strokeLinecap={"round"} cx={33} cy={33} r={30} stroke={"#ffa500"}/>
  </svg>
};

export default LoadingSpinner;